import { createSlice } from "@reduxjs/toolkit";
import { CHANGE_THEME } from "../types/theme";

const initialState = {
  darkTheme: false,
};

const Theme = createSlice({
  name: "theme",
  initialState,
  extraReducers: (builder) => {
    builder.addCase(CHANGE_THEME, (state, { payload }) => {
      state.darkTheme = payload;
    });
  },
});

export const theme = Theme.reducer;
